export * from './get-alert-color';
